export const toggleColumns = [
  { id: 1, name: "Invoice#" },
  { id: 7, name: "Date" },
  { id: 10, name: "Order By" },
  { id: 9, name: "Description" },
  { id: 10, name: "Created By" },
  { id: 10, name: "Updated By" },
];

export const searchOrderPills = [
  { id: 1, title: "Products Found", value: "2", variant: "dark" },
];

export const searchOrderTableColumns = [
  { id: 1, name: "#" },
  { id: 2, name: "ID" },
  { id: 3, name: "Amount" },
  { id: 4, name: "Date" },
  { id: 5, name: "Description" },
  { id: 6, name: "Created By" },
  { id: 7, name: "Updated By" },
];
